import { useState, useEffect } from 'react'

export interface IntroStep {
  element?: string
  intro: string
  position?: string
}

export function useIntroGuide() {
  const [introEnabled, setIntroEnabled] = useState(false)
  const [introSteps, setIntroSteps] = useState<IntroStep[]>([])
  const [introStepsIndex, setIntroStepsIndex] = useState(0)

  useEffect(() => {
    // Initialize the intro steps - moved from the Flow component
    setIntroSteps([
      {
        element: '.app-title',
        intro:
          'Welcome to Spechops! This is your project workspace for creating and connecting various nodes.',
        position: 'bottom',
      },
      {
        element: '.user-profile-button',
        intro:
          'Access your profile settings and manage your account from here.',
        position: 'bottom-left-aligned',
      },
      {
        element: '.theme-toggle-button',
        intro: 'Toggle between light and dark themes to suit your preference.',
        position: 'bottom',
      },
      {
        element: '.projectfilesfolder-button',
        intro:
          'Access your project files and upload new resources to use in your nodes.',
        position: 'right',
      },
      {
        element: '.pi-question-circle',
        intro: 'Open this help guide anytime you need assistance.',
        position: 'right',
      },
      {
        element: '.pi-search',
        intro:
          'Search for specific nodes in your project to quickly navigate to them.',
        position: 'left',
      },
      {
        element: '.react-flow__minimap',
        intro:
          "Use the minimap for a bird's-eye view of your project. Click on any node in the minimap to navigate to it.",
        position: 'left',
      },
      {
        element: '.react-flow__controls',
        intro:
          'Use these controls to add new nodes, toggle the minimap, zoom in/out, and more.',
        position: 'right',
      },
      {
        intro:
          'Create new nodes by clicking the controls or by right-clicking anywhere on the canvas.',
        position: 'auto',
      },
      {
        intro:
          "Connect nodes by dragging from one node's handle to another to create relationships.",
        position: 'auto',
      },
      {
        intro:
          'Right-click on nodes to access node-specific actions like duplicate or delete.',
        position: 'auto',
      },
      {
        intro:
          'You can now start building your project! Drag nodes, connect them, and use the different node types to create your workflow.',
        position: 'auto',
      },
    ])
  }, [])

  const introOptions = {
    nextLabel: 'Next',
    prevLabel: 'Back',
    skipLabel: 'Skip',
    doneLabel: 'Done',
    hidePrev: false,
    hideNext: false,
    tooltipClass: 'flow-tooltip',
    highlightClass: 'flow-highlight',
    exitOnEsc: true,
    exitOnOverlayClick: false,
    showStepNumbers: true,
    keyboardNavigation: true,
    showButtons: true,
    showBullets: true,
    showProgress: true,
    scrollToElement: true,
    overlayOpacity: 0.8,
  }

  const handleIntroComplete = () => {
    setIntroEnabled(false)
    localStorage.setItem('intro.jsComplete', JSON.stringify({ complete: true }))
  }

  return {
    introEnabled,
    setIntroEnabled,
    introSteps,
    introStepsIndex,
    setIntroStepsIndex,
    introOptions,
    handleIntroComplete,
  }
}
